"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedicons = require("@bit/gerenciatd.unifiedicons.svg-icon");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pathMedium = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    transform: "translate(8.603 11.611)",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M6.632,8.487A2.675,2.675,0,0,1,4.7,7.894,1.869,1.869,0,0,1,4.25,7.17,3.326,3.326,0,0,1,4.106,6.1V2.212H5.5V6.1a2.34,2.34,0,0,0,.067.607A.9.9,0,0,0,5.8,7.12a1.2,1.2,0,0,0,.9.3,1.194,1.194,0,0,0,.89-.288.9.9,0,0,0,.229-.4,2.329,2.329,0,0,0,.067-.611v-3.9H9.122v3.83a3.68,3.68,0,0,1-.139,1.074,1.716,1.716,0,0,1-.463.76,2.1,2.1,0,0,1-.8.449A3.481,3.481,0,0,1,6.632,8.487Zm6-5.358H9.761V2.212H13.77a.748.748,0,0,1,.063.369,2.563,2.563,0,0,1-.144.881l-1.726,4.9H10.588Zm1.726-.917h1.9a5.887,5.887,0,0,1,1.488.157,2.1,2.1,0,0,1,.966.535,3.182,3.182,0,0,1,.746,2.355,4.811,4.811,0,0,1-.184,1.425,2.467,2.467,0,0,1-.562.984,2.077,2.077,0,0,1-.894.521,4.707,4.707,0,0,1-1.371.171H14.354Zm2,5.124a1.476,1.476,0,0,0,1.321-.548,1.734,1.734,0,0,0,.252-.611A4.641,4.641,0,0,0,18,5.26a3.985,3.985,0,0,0-.1-1.007,1.445,1.445,0,0,0-.333-.611,1.172,1.172,0,0,0-.53-.31,3.1,3.1,0,0,0-.845-.094h-.432v4.1Z",
      transform: "translate(0 2.132)",
      fill: "#fff"
    })
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    transform: "translate(-37)",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(143.5 86.2)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        transform: "translate(-99.5 -76.2)",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M21.549,17.06H4.567a4.576,4.576,0,0,1-3.425-1.234A4.57,4.57,0,0,1,0,12.48V4.528C0,1.614,1.627,0,4.567,0H21.549c2.94.013,4.567,1.614,4.567,4.541v7.953a4.607,4.607,0,0,1-1.142,3.333,4.638,4.638,0,0,1-3.425,1.234M4.567,1.5A3.175,3.175,0,0,0,2.2,2.257a3.122,3.122,0,0,0-.722,2.283v7.953c0,2.1.984,3.071,3.084,3.071H21.549c2.1,0,3.084-.984,3.084-3.071V4.541a3.159,3.159,0,0,0-.722-2.283A3.21,3.21,0,0,0,21.549,1.5Z",
          transform: "translate(0 0)",
          fill: "#fff"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M76.17,142.5H69.648a.748.748,0,0,1,0-1.5H76.17a.748.748,0,0,1,.748.748.761.761,0,0,1-.748.748",
          transform: "translate(-59.858 -122.496)",
          fill: "#fff"
        })]
      })
    })
  })]
});

var U7D = function U7D(props) {
  var kind = props.kind;
  var path = null;

  switch (kind) {
    default:
      path = pathMedium;
  }

  var viewBox = props.viewBox,
      mainDimension = props.mainDimension;

  if (!viewBox) {
    viewBox = '7 8 26.1 26.1';
  }

  if (!mainDimension) {
    mainDimension = 'x';
  }

  var Icon = (0, _gerenciatdUnifiedicons.CreateSvgIcon)(path, "U7D-".concat(kind));
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: viewBox,
    mainDimension: mainDimension
  }));
};

var _default = U7D;
exports["default"] = _default;

//# sourceMappingURL=index.js.map